import type { ShipmentLocation } from '@fv/client-types'
import type { Workflow } from '@fv/models'

import { locationToFormStop } from '@/utils/locationFuncs'
import { defaultStopDate } from '@/utils/shipmentFuncs'

import { AutofillPreviousShipment } from '../shipment-form/AutofillPreviousShipment'
import {
  defaultDestination,
  defaultOrigin,
} from '../shipment-location-form/types'
import {
  useQuoteFormActions,
  useQuoteFormLocations,
  useQuoteFormState,
} from './useQuoteFormState'

const workflow: Workflow = 'truckload'
export const QuoteRequestAutofill = () => {
  const { addLoads, removeStop, removeLoads, addStops, setStopData } =
    useQuoteFormActions()
  const stops = useQuoteFormLocations()
  const selectedTemplateId = useQuoteFormState(s => s.selectedTemplate?._id)
  const destinationIx = stops.length - 1

  const setIntermediateStops = (
    locations: ShipmentLocation[],
    enabled: boolean,
  ) => {
    stops
      .filter(s => s.type === 'stop')
      .map(s => s.sequence)
      .reverse() // have to reverse to ensure stop isn't moved up in list when removing
      .forEach(s => removeStop(s))

    if (!enabled) return

    const newStops = locations.filter(l => l.type === 'stop')
    addStops(newStops.length)
    newStops.forEach(stop => {
      setStopData(stop.sequence, {
        ...locationToFormStop(stop, workflow),
        stopDate: null,
      })
    })
  }

  return (
    <div className="bg-fv-beer-xlight border-fv-beer-medium flex items-center border-b border-dashed px-6 py-4 -mt-8 -mx-6 mb-8">
      <AutofillPreviousShipment
        workflow={workflow}
        selectedTemplateId={selectedTemplateId}
        handlers={{
          origin: (loc, enabled) =>
            setStopData(
              0,
              enabled && loc
                ? {
                    ...locationToFormStop(loc, workflow),
                    stopDate: defaultStopDate('origin'),
                    refNum: '',
                  }
                : defaultOrigin(),
            ),
          destination: (loc, enabled) =>
            setStopData(
              destinationIx,
              enabled && loc
                ? locationToFormStop(
                    { ...loc, sequence: destinationIx },
                    workflow,
                  )
                : defaultDestination(destinationIx),
            ),
          equipment: (equipment, enabled) =>
            equipment.forEach(e =>
              enabled ? addLoads(e.type, 1, e) : removeLoads(e.type),
            ),
          stops: setIntermediateStops,
        }}
      />
    </div>
  )
}
